import { render, staticRenderFns } from "./MyPasswordChange.vue?vue&type=template&id=cc969b1e&scoped=true&"
import script from "./MyPasswordChange.vue?vue&type=script&lang=js&"
export * from "./MyPasswordChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc969b1e",
  null
  
)

export default component.exports